import { Typography, makeStyles, Divider, Grid, List, ListItem } from '@material-ui/core'
import { default as Tile } from 'components/Tile/Tile'
import View from '../View'
import { Logo } from 'components'
import { Link } from 'react-router-dom'
import creditsAvatar from '../../images/avatar/roy-cartoon-profile-200.png'
import HeroButton from 'helpers/HeroButton'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { faBolt, faBox, faFistRaised, faGhost, faHeart, faUsers, faWarehouse } from '@fortawesome/free-solid-svg-icons'




// Simple <P> tag wrapper
const P = ({ children }: { children: React.ReactNode }) => (
    <Typography>{children}</Typography>
)

const B = ({ children }: { children: React.ReactNode }) => (
    <Typography display='inline' color='secondary' component='span'>{children}</Typography>
)

const useStyles = makeStyles((theme) => ({
    root: {
    },
    skySpace: {
        minHeight: '20vh',
    },
    logoHouse: {
        display: 'flex',
        justifyContent: 'center',
    },
    logoRoom: { // Vertically center
        display: 'flex',
        alignItems: 'center'
    },
    flexCenter: {
        display: 'flex',
        justifyContent: 'center'
    },
    flexBullseye: {
    },
    textCenter: {
        textAlign: 'center',
    },
    flexBetween: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    inBox: {
        justifyContent:'center',
        minHeight: '5rem',
        textAlign: 'center',
    },
    brightImpact: {
        textTransform: 'uppercase',
        color: '#ffffff',
        paddingBottom: '1rem',
        wordBreak: 'break-word',
    },
    darkImpact: {
        textTransform: 'uppercase',
        color: '#333333',
        paddingBottom: '1rem',
        wordBreak: 'break-word',
    },
    bSpace: {
        marginBottom: '1.5rem'
    }
}))

/**
 * Homepage introductory information and content
 */
const Home = () => {
    const classes = useStyles()
    return (
        <View title='Ninjawars - Live by the Shuriken' header=''>
            <Tile theme='dark' compact={false}>
                <article className={classes.skySpace}>
                    <div className={classes.logoHouse}>
                        <header>
                            <Logo />
                            <div className={classes.logoRoom}>
                                <Typography variant="h4" color="textSecondary">Live by the Shuriken</Typography>&nbsp;
                                <Typography variant='h5' color='primary'>by Roy Ronalds</Typography>
                            </div>
                        </header>
                    </div>
                </article>
            </Tile>
            <Tile theme='light' compact={false}>
                <article>
                    <Grid container className={classes.flexBullseye} justifyContent='center'>
                        <Grid item xs={12} md={6} lg={4} className={classes.inBox}>
                            <header className={classes.bSpace}>
                                <Typography variant="h2" className={classes.darkImpact}>Fight Ninja!</Typography>
                                <Typography variant='subtitle1'><Link to='/fight'><Icon icon={faFistRaised} /> Attack other ninja</Link>, get stronger at the <Link to='/dojo'><Icon icon={faWarehouse} /> Dojo</Link></Typography>
                            </header>
                            <Divider />
                        </Grid>
                    </Grid>
                    <Grid container justifyContent='space-between' spacing={2}>
                        <Grid item xs={12} md={4}>
                            <Typography variant='subtitle1'>
                                <Link to='/map'>Explore the Map</Link>
                            </Typography>
                            <P>Explore the <Link to='/map'><Icon icon={faBox} /> map</Link>, <Link to='/fight'><Icon icon={faBolt} /> attack monsters</Link>, and <Link to='/inventory'><Icon icon={faBox} /> gather loot</Link></P>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Typography variant='subtitle1'>
                                <Link to='/clan'>Join a Clan</Link>
                            </Typography>
                            <P>Pick a <Icon icon={faUsers} /> clan, join it&apos;s membership, or grow strong enough to create your own, and then wage war on other ninja clans.</P>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Typography variant='subtitle1'>
                                <Link to='/shrine'>Avoid Death</Link>
                            </Typography>
                            <P>Live by the Shuriken, and avoid death <Icon icon={faGhost} /> if you can, or else prepare to embrace it.</P>
                        </Grid>
                    </Grid>
                </article>
            </Tile>
            <Tile theme='dark' compact={false}>
                <article>
                    <Grid container className={classes.flexBullseye} justifyContent='center'>
                        <Grid item xs={12} md={6} lg={4} className={classes.inBox}>
                            <Typography className={classes.brightImpact} variant='h2'>Becoming a Ninja</Typography>
                            <P>Becoming a <B>ninja</B> gets you some strength, speed, and stamina. Whether you attack the <B>rebellious peasants</B> or rebel against the <B>tyrant emperor</B> is up to you.</P>
                            <br/>
                            <HeroButton to='/signup'>Start the Game!</HeroButton>
                        </Grid>
                    </Grid>
                </article>
            </Tile>
            <Tile theme='light' compact={false}>
                <article>
                    <Grid container className={classes.flexBullseye} justifyContent='center'>
                        <Grid item xs={12} md={6} lg={4} className={`${classes.inBox} ${classes.bSpace}`}>
                            <header>
                                <Typography variant='h2'>
                                    Built with Love <Icon icon={faHeart} />
                                </Typography>
                                <Typography className={classes.bSpace} variant='subtitle1'>Created with care by Roy Ronalds and the rest of the NinjaWars team since 2002</Typography>
                            </header>
                            <Typography className={classes.bSpace} variant="h3" color="textSecondary">Credits</Typography>
                            <Typography>I&apos;m a game developer &amp; software architect, and have been coding ninjawars since about 2003.</Typography>
                            <Divider />
                            <img src={creditsAvatar} alt='' />
                            <div>
                                <Typography color='textSecondary' variant='caption'>Roy Ronalds</Typography>
                            </div>
                            <Typography color='textSecondary'>Game Dev &amp; Web Software Architect</Typography>
                            <P>Ninja: Tchalvak</P>
                        </Grid>
                        <Grid item xs={10} style={{ textAlign: 'center' }}>
                            <div style={{ display: 'inline-block' }}>
                                <Typography variant='h6' className={classes.darkImpact}>OTHER CONTRIBUTIONS</Typography>
                                <section>
                                    <List>
                                        <ListItem>NinjaLord / John Facey, II • Founder &amp; Original Creator of NinjaWars {/*-  <Link to='/interview'>Archived interview</Link> */}</ListItem>
                                        <ListItem>Beagle • &nbsp;<a href='http://github.com/beagle'>Long-time developer</a></ListItem>
                                        <ListItem>Other developers &amp; planners at various points • chrismonster, kultcher, sparky, &amp; suavisimo</ListItem>
                                        <ListItem>DeathDepiction • Certain NPCs and other code contributions</ListItem>
                                        <ListItem>Magatsu • a few of the early Shop Graphics</ListItem>
                                        <ListItem>Some pixel art by Roy Ronalds</ListItem>
                                    </List>
                                </section>
                            </div>
                        </Grid>
                    </Grid>
                </article>
            </Tile>
            <Tile theme='dark' compact={false}>
                <article>
                    <Grid container className={classes.flexBullseye} justifyContent='center'>
                        <Grid item xs={12} md={6} lg={4} className={classes.inBox}>
                            <Typography className={classes.brightImpact} variant="h2">Contact Us</Typography>
                            <P>Join the discussion of ninjawars</P>
                            <div><a href='https://www.facebook.com/ninjawars.net/'>Ask a question on facebook</a></div>
                        </Grid>
                    </Grid>
                </article>
            </Tile>
        </View>
    )
}

export default Home
